import * as React from 'react';
import { GridFilterCellProps } from '@progress/kendo-react-grid';
import { DatePicker, DatePickerChangeEvent } from '@progress/kendo-react-dateinputs';
import { Button } from '@progress/kendo-react-buttons';
import { filterClearIcon } from '@progress/kendo-svg-icons';
import { useTranslation } from 'react-i18next';
import { GridFilterOperator } from '@progress/kendo-react-grid/dist/es/interfaces/GridFilterOperator';
import { DateFormatEnum } from '../../store/user/types.d';
import { AppDispatch } from '../../store/store';
import { AppState } from '../../store/state';
import { selectCurrentUser } from '../../store/selectors';
import { connect } from 'react-redux';
import { DropDownList, DropDownListChangeEvent } from '@progress/kendo-react-dropdowns';

const dateOperators: GridFilterOperator[] = [
  { text: 'Equals', operator: 'eq' },
  { text: 'Not equal', operator: 'neq' },
  { text: 'After', operator: 'gt' },
  { text: 'After or equal', operator: 'gte' },
  { text: 'Before', operator: 'lt' },
  { text: 'Before or equal', operator: 'lte' },
  { text: 'Is null', operator: 'isnull' },
  { text: 'Is not null', operator: 'isnotnull' },
];

interface CustomDateFilterCellProps extends GridFilterCellProps {
  dateFormat: string;
}

const DateFilterCell: React.FC<CustomDateFilterCellProps> = (props) => {
  const { t, i18n } = useTranslation();

  const onOperatorChange = (e: DropDownListChangeEvent) => {
    const item = e.value as GridFilterCellProps;

    props.onChange({
      value: props.value,
      operator: item.operator ?? '',
      syntheticEvent: e.syntheticEvent,
    });
  };

  const onChange = (event: DatePickerChangeEvent) => {
    props.onChange({
      value: event.value,
      operator: props.operator ?? defaultOperator?.operator,
      syntheticEvent: event.syntheticEvent,
    });
  };

  const onClearClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    props.onChange({
      value: null,
      operator: '',
      syntheticEvent: e,
    });
  };

  const itemRender = (props_: { item: GridFilterOperator; itemIndex: number }) => {
    const { item: operator } = props_;
    const isSelected = operator.operator === props.operator;

    return (
      <div className={isSelected ? 'is-selected k-flex k-items-center' : 'k-flex k-items-center'}>{operator.text}</div>
    );
  };

  const defaultOperator = dateOperators.find((item) => item.operator === 'gte');

  return (
    <div className="k-filtercell">
      <div className="k-filtercell-wrapper">
        <DatePicker value={props.value} onChange={onChange} format={props.dateFormat.split(' ')[0]} />
        <DropDownList
          data={dateOperators}
          textField="text"
          dataItemKey="operator"
          onChange={onOperatorChange}
          value={dateOperators.find((item) => item.operator === props.operator)}
          popupSettings={{ width: '9rem', height: '12rem' }}
          className="k-dropdownlist k-picker k-dropdown-operator k-picker-md k-rounded-md k-picker-solid"
          iconClassName="k-icon k-i-filter k-button-icon"
          style={{ height: '1.875rem', width: '1.875rem' }}
        />
        {/*          <DropDownButton
            items={numericOperators}
            onItemClick={onOperatorChange}
            // Optional: keep height similar to the other controls
            style={{ height: '1.875rem', width: '1.875rem' }}
            svgIcon={filterIcon}
            title={t('Choose Operator')}
            itemRender={itemRender}
            className="k-dropdownlist k-dropdown-operator"
            iconClassName="k-icon k-i-filter k-button-icon"
          />*/}
        <Button
          title={t('Clear')}
          disabled={!props.operator}
          onClick={onClearClick}
          svgIcon={filterClearIcon}
          style={{ height: '1.875rem', width: '1.875rem' }}
        />
      </div>
    </div>
  );
};

const mapStateToProps = (state: AppState) => ({
  dateFormat: selectCurrentUser(state).person.date_format ?? DateFormatEnum.DMY24,
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(DateFilterCell);
